import { render, staticRenderFns } from "./eod-events-table.vue?vue&type=template&id=21847eff&scoped=true"
import script from "./eod-events-table.vue?vue&type=script&lang=js"
export * from "./eod-events-table.vue?vue&type=script&lang=js"
import style0 from "./eod-events-table.vue?vue&type=style&index=0&id=21847eff&prod&lang=scss&scoped=true"
import style1 from "./eod-events-table.vue?vue&type=style&index=1&id=21847eff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21847eff",
  null
  
)

export default component.exports